import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Trans, useTranslation } from "react-i18next";
import "./ReportTermsDialog.css";

const CONTACT_US_EMAIL = "enquiries@idwalmarine.com";

type ReportTermsDialogProps = {
  visible: boolean;
  customerName?: string | null;
  customerOrganisation?: string | null;
  onAgree: () => void;
  onHide: () => void;
};

export const ReportTermsDialog = (props: ReportTermsDialogProps) => {
  const { visible, customerName, customerOrganisation, onAgree, onHide } =
    props;
  const { t } = useTranslation("locale");

  return (
    <Dialog
      header={t("defectsSummary.termsHeader")}
      visible={visible}
      onHide={onHide}
      style={{ maxWidth: 600 }}
      blockScroll
      draggable={false}
      data-cy="report-terms-dialog"
    >
      <p className="mt-0 mb-3">
        <Trans
          i18nKey="defectsSummary.terms1"
          t={t}
          values={{
            customerName: customerName ?? "",
            organisation: customerOrganisation ?? "",
          }}
          components={{ 1: <strong />, 2: <strong /> }}
        />
      </p>
      <p className="mt-0 mb-3">
        <Trans
          i18nKey="defectsSummary.terms2"
          t={t}
          components={{
            1: (
              <a
                className="report-terms-link"
                content={t("defectsSummary.emailAnchorContent")}
                href={`mailto:${CONTACT_US_EMAIL}`}
              />
            ),
          }}
        />
      </p>
      <div className="mt-4 w-full flex align-items-center justify-content-center gap-4">
        <Button
          className="p-button p-component p-button-text"
          label={t("defectShareActionPlan.cancel")}
          onClick={onHide}
          data-cy="report-terms-cancel"
        />
        <Button
          label={t("defectsSummary.agreeAndDownload")}
          onClick={onAgree}
          data-cy="report-terms-agree"
        />
      </div>
    </Dialog>
  );
};
